
import * as ipxRuntime$esGK8AMgKa from '/opt/dasei/source/node_modules/.pnpm/@nuxt+image@1.7.0_ioredis@5.4.1_magicast@0.2.11_rollup@4.24.4/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$esGK8AMgKa, defaults: {} }
}
        